import { IIconProps } from '../../types/IconProps.interface'

export const IconAiUser = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 23 23'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1 12.3333C2.55719 10.6817 4.67135 9.66667 7 9.66667C9.32867 9.66667 11.4428 10.6817 13 12.3333M10 4C10 5.65685 8.65687 7 7 7C5.34315 7 4 5.65685 4 4C4 2.34315 5.34315 1 7 1C8.65687 1 10 2.34315 10 4Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        clipRule='evenodd'
        d='M14.862 14.5076C15.0931 13.8308 16.0502 13.8308 16.2814 14.5076L16.9801 16.5532C17.0552 16.7729 17.2278 16.9454 17.4474 17.0205L19.4931 17.7192C20.1699 17.9504 20.1699 18.9075 19.4931 19.1387L17.4474 19.8374L17.3676 19.8696C17.1862 19.9559 17.0458 20.1123 16.9801 20.3047L16.2814 22.3503L16.2301 22.4697C15.9534 22.9878 15.19 22.9878 14.9132 22.4697L14.862 22.3503L14.1632 20.3047C14.0975 20.1124 13.9572 19.9559 13.7758 19.8696L13.696 19.8374L11.6503 19.1387C11.0159 18.922 10.9759 18.067 11.5309 17.7705L11.6503 17.7192L13.696 17.0205C13.8883 16.9548 14.0447 16.8145 14.131 16.6331L14.1632 16.5532L14.862 14.5076Z'
        fill={'#A059FF'}
        fillRule='evenodd'
      />
      <path
        d='M21.4999 14.375C21.707 14.375 21.8749 14.5429 21.8749 14.75V15.5H22.6249C22.832 15.5 22.9999 15.6679 22.9999 15.875C22.9999 16.0821 22.832 16.25 22.6249 16.25H21.8749V17C21.8749 17.2071 21.707 17.375 21.4999 17.375C21.2929 17.3749 21.1249 17.207 21.1249 17V16.25H20.3749C20.1679 16.2499 19.9999 16.082 19.9999 15.875C19.9999 15.668 20.1679 15.5001 20.3749 15.5H21.1249V14.75C21.1249 14.543 21.2929 14.3751 21.4999 14.375Z'
        fill={'#A059FF'}
      />
      <path
        d='M18.8749 11C19.082 11 19.2499 11.1679 19.2499 11.375V12.5H20.3749C20.582 12.5 20.7499 12.6679 20.7499 12.875C20.7499 13.0821 20.582 13.25 20.3749 13.25H19.2499V14.375C19.2499 14.5821 19.082 14.75 18.8749 14.75C18.6679 14.7499 18.4999 14.582 18.4999 14.375V13.25H17.3749C17.1679 13.2499 16.9999 13.082 16.9999 12.875C16.9999 12.668 17.1679 12.5001 17.3749 12.5H18.4999V11.375C18.4999 11.168 18.6679 11.0001 18.8749 11Z'
        fill={'#A059FF'}
      />
    </svg>
  )
}
